var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMagenta)?_c('tmo-digital-header',{attrs:{"theme":"light"}}):_c('tmo-digital-header',{attrs:{"brand":"metro","client-id":"metro"}})
}
var staticRenderFns = []

export { render, staticRenderFns }